import { render, staticRenderFns } from "./AboutMembersIndex2.vue?vue&type=template&id=20fe3ad9&"
import script from "./AboutMembersIndex2.vue?vue&type=script&lang=js&"
export * from "./AboutMembersIndex2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports